'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'image-polaroid';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8c4';
var svgPathData = 'M400 368L48 368l0 64 352 0 0-64zM75.3 320l57.3-78.2L152 215.4l19.4 26.4L188 264.4l56-85.6L264 148.1l20.1 30.7L376.4 320l23.6 0 0-240L48 80l0 240 27.3 0zM448 320l0 24 0 24 0 64 0 48-48 0L48 480 0 480l0-48 0-64 0-24 0-24L0 80 0 32l48 0 352 0 48 0 0 48 0 240zM80 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImagePolaroid = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;